<template>
  <div>
    <div>
      <van-nav-bar
        title="秩序册"
        left-text="返回"
        right-text=""
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="margin-top:50px"></div>
    <van-tabs v-model="xmModelData" @change="toTab">
      <van-tab
        v-for="(item, index) in XMLIST"
        :key="index"
        :title="item.XMQC"
        :name="item.XMID + '|' + item.SZZLDM"
      ></van-tab>
    </van-tabs>
    <tts-view-com
      v-if="sszl === 'TT'"
      queryType="ZXC"
      :ssid="ssid"
      :resultList="resultList"
    ></tts-view-com>
    <xhs-view-com
      queryType="ZXC"
      :resultList="resultList"
      :ssid="ssid"
      v-if="sszl === 'XH' && LZGZID !== '5'"
    ></xhs-view-com>

    <sls-cd-view-com
      queryType="ZXC"
      :resultList="resultList"
      v-if="sszl === 'XH' && LZGZID === '5'"
    ></sls-cd-view-com>

    <loading-com />
    <!-- 返回顶部按钮 -->
    <back-to-top-com />
    <div style="height:100px;width:15px;"></div>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import TtsViewCom from "../commonCom/TtsViewCom.vue";
import XhsViewCom from "../commonCom/XhsViewCom.vue";
import SlsCdViewCom from "../commonCom/SlsCdViewCom.vue";
import BackToTopCom from "../commonCom/BackToTopCom.vue";
export default {
  name: "ZxcIndex",
  components: {
    TtsViewCom,
    LoadingCom,
    XhsViewCom,
    SlsCdViewCom,
    BackToTopCom
  },
  data() {
    return {
      utilPost: "",
      ssid: "",
      sszl: "",
      xmid: "",
      resultList: [],
      XMQC: "全称+组别",
      LZGZID: "",
      routeValue: "",
      XMLIST: [],
      xmModelData: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.sszl = this.$route.query.sszl;
    this.xmid = this.$route.query.xmid;
    this.xmModelData = this.xmid + "|" + this.sszl;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainLoadData();
  },
  methods: {
    toTab() {
      var arary = this.xmModelData.split("|");
      this.xmid = arary[0];
      this.sszl = arary[1];
      this.mainLoadData();
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    mainLoadData() {
      var busData = {
        XMID: this.xmid,
        SSZL: this.sszl
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getZxcData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.LZGZID = data.lsData.LZGZID;
        this.XMLIST = data.lsData.XMLIST;
        this.resultList = data.content;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ZxcIndex/ZxcIndex.vue